import { render, staticRenderFns } from "./SelectModule.vue?vue&type=template&id=5008e4e9&scoped=true"
import script from "./SelectModule.vue?vue&type=script&lang=js"
export * from "./SelectModule.vue?vue&type=script&lang=js"
import style0 from "./SelectModule.vue?vue&type=style&index=0&id=5008e4e9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008e4e9",
  null
  
)

export default component.exports